var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgPause = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.53125 4.875C6.06526 4.875 5.6875 5.25276 5.6875 5.71875V20.2812C5.6875 20.7472 6.06526 21.125 6.53125 21.125H9.71875C10.1847 21.125 10.5625 20.7472 10.5625 20.2812V5.71875C10.5625 5.25276 10.1847 4.875 9.71875 4.875H6.53125ZM16.2812 4.875C15.8152 4.875 15.4375 5.25276 15.4375 5.71875V20.2812C15.4375 20.7472 15.8152 21.125 16.2812 21.125H19.4687C19.9347 21.125 20.3125 20.7472 20.3125 20.2812V5.71875C20.3125 5.25276 19.9347 4.875 19.4687 4.875H16.2812Z",
    fill: "currentColor"
  })));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgPause);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/pause.8547c9ece52b1bcdf82edc712ce02cf3.svg";